import React , {Component} from 'react';
import Icon from './Icon';
import './ActionButton.css';

export default class ActionButton extends Component{
    render(){
        let {className, ...props} = this.props;
        return(
            <div className={"table align-middle align-center action-btn " + (this.props.className || '')} {... props}>
                <div>
                    <div><Icon icon={this.props.actionIcon || 'edit'} /></div>
                </div>                
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ActionButton.js